var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThankyouActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 22.83 23.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.01,23.67h-7.33v-1.13h6.2V2.04c0-.5-.41-.91-.91-.91H7.41c-.51,0-.93,.42-.93,.93v7.53h-1.13V2.05c0-1.13,.92-2.05,2.05-2.05h10.56c1.13,0,2.04,.92,2.04,2.04V23.67Z",
    fill: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.44,
    y: 22.54,
    width: 3.38,
    height: 1.13,
    fill: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.48,
    y: 11.5,
    width: 2.25,
    height: 1.13,
    fill: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.28,
    y: 13.65,
    width: 8.65,
    height: 9.46,
    rx: 0.7,
    ry: 0.7,
    fill: "#3D6AAE"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.23,23.39H.98c-.54,0-.98-.44-.98-.98V14.35c0-.54,.44-.98,.98-.98h7.24c.54,0,.98,.44,.98,.98v8.06c0,.54-.44,.98-.98,.98ZM.98,13.93c-.23,0-.42,.19-.42,.42v8.06c0,.23,.19,.42,.42,.42h7.24c.23,0,.42-.19,.42-.42V14.35c0-.23-.19-.42-.42-.42H.98Z",
    fill: "#1b1b1b"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.32,13.42h-.56s0-.74-.27-1.44c-.33-.88-.9-1.33-1.7-1.33-1.95,0-1.97,2.66-1.97,2.77h-.56c0-1.15,.53-3.33,2.54-3.33,.63,0,1.16,.21,1.58,.63,.95,.95,.95,2.63,.95,2.71Z",
    fill: "#1b1b1b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyouActive);
export default __webpack_public_path__ + "static/media/thankyouActive.1db2fc2c6458596605501644264509c0.svg";
export { ForwardRef as ReactComponent };